import { merge } from 'lodash';

const getArquivoState = () => ({
  id: "",
  fileObj: undefined,
  delimitador: `;`,
  involucro: `"`,
  escape: `"`,
  uploading: false,
  fakeFile: false,
  headerValido: false
});

const initialState = {
  titulo: '',
  anoMesCorteUltimoCiclo: null, /* DATABASE Laudo Blndado */
  versao: null,
  versoesDisponiveis: [],
  versoesLoading: false,
  atualizarAte: null, /* IPCA */
  arquivoBaixas: getArquivoState(),
  arquivoTransferencias: getArquivoState(),
  arquivoIa: getArquivoState(),
  arquivoElegibilidade: getArquivoState()
};
  
const state = initialState;
  
const getters = {};
  
const actions = {
  setMovimentacaoBlindada({ commit }, value) {
    commit('SET_MOVIMENTACAO_BLINDADA', value)
  },
  clearMovimentacaoBlindada({ commit }, value) {
    commit('CLEAR_MOVIMENTACAO_BLINDADA', initialState)
  }
};
  
const mutations = {
  SET_MOVIMENTACAO_BLINDADA: (state, value) => (state = merge(state, value)),
  CLEAR_MOVIMENTACAO_BLINDADA: (state, value) => {
    state = merge(state, value);
    state.arquivoBaixas.fileObj = undefined;
    state.arquivoTransferencias.fileObj = undefined;
    state.arquivoIa.fileObj = undefined;
    state.arquivoElegibilidade.fileObj = undefined;
  }
};
  
export default {
  state,
  getters,
  actions,
  mutations
};
